export interface NetworkConfig {
  chainId: number;
  name: string;
  shortName: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  rpcUrl: string;
  blockExplorer: string;
  isSettlementChain: boolean;
  contracts: {
    settler?: string;
    collector?: string;
    usdt: string;
    wmatic: string;
    swapRouter: string;
  };
  ccipChainSelector: string;
}

// ============ POLYGON MAINNET CONFIGURATION ============
// All addresses verified on PolygonScan - DO NOT MODIFY without verification
export const NETWORKS: Record<string, NetworkConfig> = {
  polygon: {
    chainId: 137,
    name: "Polygon",
    shortName: "Polygon",
    nativeCurrency: {
      name: "POL",
      symbol: "POL",
      decimals: 18,
    },
    rpcUrl: "https://polygon-bor-rpc.publicnode.com",
    blockExplorer: "https://polygonscan.com",
    isSettlementChain: true,
    contracts: {
      // Deployed contract addresses - Polygon Mainnet
      settler: "0x145Cbbdbd9a8D1189F3800aa54d2B486FC43c7f7", // BettingSettler (v3 with 10% fee)
      collector: "0x91bd06342CDf2c097a083ebc13957c0195319864", // PolygonCollector
      // Verified token addresses
      usdt: "0xc2132D05D31c914a87C6611C10748AEb04B58e8F", // USDT (6 decimals)
      wmatic: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270", // WMATIC (18 decimals)
      swapRouter: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff", // QuickSwap V2 Router
    },
    ccipChainSelector: "4051577828743386545",
  },
};

export const SETTLEMENT_CHAIN = NETWORKS.polygon;

export const getNetworkByChainId = (chainId: number): NetworkConfig | undefined => {
  return Object.values(NETWORKS).find((n) => n.chainId === chainId);
};

export const getSupportedChainIds = (): number[] => {
  return Object.values(NETWORKS).map((n) => n.chainId);
};

export const isChainSupported = (chainId: number): boolean => {
  return getSupportedChainIds().includes(chainId);
};

export default NETWORKS;
